var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-content',[(_vm.$router.currentRoute.path !== '/login')?_c('v-header'):_vm._e(),_c('router-view')],1),(_vm.showLoaderCircular)?_c('div',{staticClass:"loaderWrapper"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":'#89bc41',"indeterminate":""}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }